import React from 'react';
import { Link } from 'gatsby';
import slugify from 'slugify';

const OutboundLinks = (props) => {
  const formatClass = `product-view__outbound-links__${props.format}`;

  return (
    <div className={`product-view__outbound-links ${formatClass}`}>
      <p className="header">
        Browse more Fine Art Prints
      </p>
      <div className="links">
        {(props.productData.Style) ? (
          props.productData.Style.map((style, idx) => (
            <>
              <Link
                key={`style-link-${idx}`}
                to={`/shop/fine-art-prints/style/${slugify(style.toLowerCase())}`}
              >
                {style}
              </Link>{' '}
            </>
          ))
        ): null}
        {(props.productData.Subject) ? (
          props.productData.Subject.map((subject, idx) => (
            <>
              <Link
                key={`subject-link-${idx}`}
                to={`/shop/fine-art-prints/subject/${slugify(subject.toLowerCase())}`}
              >
                {subject}
              </Link>{' '}
            </>
          ))
        ) : null}
        {(props.productData.Century) ? (
          props.productData.Century.map((century, idx) => (
            <>
              <Link
                key={`century-link-${idx}`}
                to={`/shop/fine-art-prints/century/${slugify(century.toLowerCase())}`}
              >
                {century}
              </Link>{' '}
            </>
          ))
        ) : null}
      </div>
    </div>
  );
}

export default OutboundLinks;